<div class="footer">
    <div class="outer">
        <div class="links">
            <img class="logo" src="assets/images/Avenir-Energy-Logo-Primary-Vertical.svg">
            <div class="sec d-flex flex-column gap-3">
                <div class="d-flex flex-column gap-4">
                    <div class="backtotop d-flex flex-row g-2" (click)="scrollToTop()">
                        <img src="assets/icons/arrow_up.svg" alt="" class="up-icon">
                        <h6 class="sec-header"><ng-container i18n="@@backToTop">Back To Top</ng-container></h6>
                    </div>
                    <div class="right-side d-flex flex-row gap-4">
                        <div class="copyright">
                            <p class="copyright-text"><ng-container i18n="@@copyright">Copyright</ng-container> © 2024
                                <ng-container i18n="@@allRightsReserved">All rights reserved.</ng-container></p>
                            <a class="privacy-policy" href="https://avenirenergy.ca/privacy-policy/"
                                target="_blank"><ng-container i18n="@@privacyPolicy">Privacy Policy</ng-container></a>
                        </div>
                        <div class="external-links-container d-flex flex-row gap-4">
                            <a href="https://www.facebook.com/people/Avenir-Energy/61566284997117/?mibextid=LQQJ4d"
                                target="_blank"><img src="assets/icons/facebook.svg" alt="" class="socmed-icon"></a>
                            <a href="https://www.instagram.com/avenir.energy/" target="_blank"><img
                                    src="assets/icons/instagram-blue.svg" alt="" class="socmed-icon"></a>
                            <a href="https://www.linkedin.com/company/avenir-energy-ltd/" target="_blank"><img
                                    src="assets/icons/linkedin.svg" alt="" class="socmed-icon"></a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- <div class="copyright">
            <p class="copyright-text">Copyright © 2024 All rights reserved.</p>
            <p class="copyright-text">Privacy Policy</p>
        </div> -->
    </div>
</div>